const { v4 } = require("uuid");

module.exports = v4;
module.exports.default = v4;
